import * as React from 'react';

import { SVGProps } from '../../types';

export const IconCopy2SVG = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}

    <path
      fill="currentColor"
      d="M15.463 5a.87.87 0 0 0-.178-.343c-.113-.129-.217-.157-.285-.157H5c-.068 0-.172.028-.285.157a.957.957 0 0 0-.215.63v11.427c0 .278.1.497.215.629a.433.433 0 0 0 .227.15L5 17.5V19l-.204-.012C3.787 18.871 3 17.898 3 16.714V5.286C3 4.024 3.895 3 5 3h10c1.02 0 1.86.873 1.982 2h-1.52Z"
    />
    <path
      fill="currentColor"
      d="M18 20.5V22H8v-1.5h10Zm.5-.786V8.286c0-.278-.1-.496-.215-.629-.113-.129-.217-.157-.285-.157H8c-.068 0-.172.028-.285.157a.957.957 0 0 0-.215.63v11.427c0 .278.1.497.215.629.113.129.217.157.285.157V22l-.204-.012C6.787 21.871 6 20.898 6 19.714V8.286C6 7.024 6.895 6 8 6h10c1.105 0 2 1.024 2 2.286v11.428C20 20.976 19.105 22 18 22v-1.5c.068 0 .172-.028.285-.157a.957.957 0 0 0 .215-.63Z"
    />
    <path
      fill="currentColor"
      d="M16 10a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5h6Zm0 3a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5h6Zm-3 3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h3Z"
    />
  </svg>
);
